const ItemGenerator = require('../../../game_items/ItemGenerator.js');
const LightTorsoe = require('../../../game_items/equipment/torsoe/LightTorsoe.js');
const Staff = require('../../../game_items/equipment/weapon/Staff.js');
const getMobEquipmenAssignmentFromBags = require('./getMobEquipmenAssignmentFromBags');

const ratling_priest = (level) => {
  const handle = 'ratling_priest';
  const types = ['beast', 'healer', 'magic', 'rat'];
  const AI_PRIORITIES = ['support', 'dps_close', 'tank', 'interference', 'dps_ranged'];

  const bags = [
    {
      value: {
        items: [
          ItemGenerator.getCavernsMobItem(LightTorsoe, level),
          ItemGenerator.getCavernsMobItem(Staff, level),
        ].map((item) => ({ value: item })),
      },
    },
  ];

  return {
    handle,
    types,
    level,
    getAbilityTrees: ((bound_level) => [
      {
        handle: 'ratling_priest_abilities',
        abilities: {
          move: { handle: 'move', level: 1 },
          melee_attack: { handle: 'melee_attack', level: 1 },
          quickness: {
            handle: 'quickness',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
            passive: true,
          },
          healing_prayer: {
            handle: 'healing_prayer',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
        },
      },
    ]).bind(null, level),
    getBaseAttributes: ((bound_level) => ({
      learning: Math.round(6 + bound_level * 0.75 + Math.random() * 3),
      perception: Math.round(4 + bound_level * 0.5 + Math.random() * 3),
      mana: Math.round(5 + bound_level * 0.6 + Math.random() * 3),
      toughness: Math.round(3 + bound_level * 0.25 + Math.random() * 3),
      strength: Math.round(3 + bound_level * 0.4 + Math.random() * 3),
      willpower: Math.round(4 + bound_level * 0.6 + Math.random() * 3),
      dexterity: Math.round(5 + bound_level * 0.7 + Math.random() * 3),
    })).bind(null, level),
    getDefaultAIConfig: () => AI_PRIORITIES,
    xpValue: level * 275,
    drops_gold: true,
    drops_equipment: true,
    bags,
    build: {
      ai: {
        priorities: AI_PRIORITIES,
        settings: {
          chanceToSkipRoles: true,
          autoMove: true,
          waitForAPMP: false,
        },
      },
      ai_unit: true,
      equipment_assignment: getMobEquipmenAssignmentFromBags(bags),
      equipped_abilities: [
        { value: 'move' },
        { value: 'melee_attack' },
        { value: 'quickness' },
        { value: 'healing_prayer' },
      ],
      handle,
      level,
      team: 'black',
      types,
      unit: true,
    },
  };
};
module.exports = ratling_priest;
